import { RouteLocationNormalizedLoadedGeneric, RouteRecordNameGeneric } from 'vue-router';
import { SectionRouteNamesResearch, SectionRouteNames } from '@/routes/sectionRoutes/sectionRouteNames.ts';
import { IEnactPagesAccess } from '@/interfaces/auth/IEnactPagesAccess.ts';
import { router } from '@/router.ts';

const flattenedRoutes = router.getRoutes();

export function getResearchSectionRouteName (route: RouteLocationNormalizedLoadedGeneric, researchName: RouteRecordNameGeneric): RouteRecordNameGeneric {
    const parentRoute = route.matched.find(r => Object.values(SectionRouteNames).some(name => name === r.name));
    if (!parentRoute) return researchName;
    if (parentRoute.name === SectionRouteNames.residential || parentRoute.name === SectionRouteNames.commercialAndIndustrial) {
        return `${route.matched[1].name as string}_${researchName as string}`;
    }
    return `${parentRoute.name as string}_${researchName as string}`;
}

export function getCurrentSectionResearch (route: RouteLocationNormalizedLoadedGeneric): SectionRouteNamesResearch {
    const parentRoute = route.matched.find(r => Object.values(SectionRouteNames).some(name => name === r.name));
    if (!parentRoute) return 'general';
    if (parentRoute.name === SectionRouteNames.residential || parentRoute.name === SectionRouteNames.commercialAndIndustrial) {
        return `${route.matched[1].name as SectionRouteNamesResearch}`;
    }
    return parentRoute.name as SectionRouteNamesResearch;
}

export function getCurrentResearchAreaLabel (route: RouteLocationNormalizedLoadedGeneric): string | null {
    const currentSectionName = getCurrentSectionResearch(route);
    if (currentSectionName === 'general') return null;

    const currentSectionRoute = route.matched.find(r => r.name === currentSectionName);
    const currentSectionLabel = currentSectionRoute?.meta.headName as string | undefined;
    const parentSectionRoute = route.matched.find(r => Object.values(SectionRouteNames).some(name => name === r.name));
    const parentSectionLabel = parentSectionRoute?.meta.headName as string | undefined;

    if (!currentSectionLabel) return parentSectionLabel ?? null;
    return parentSectionLabel && parentSectionLabel !== currentSectionLabel
        ? `${parentSectionLabel} › ${currentSectionLabel}`
        : currentSectionLabel;
}

export function getRouteAccess (enactPageAccess: IEnactPagesAccess | undefined, route: string): { hasAccess: boolean; accessRequired: string } {
    const noAccess = { hasAccess: false, accessRequired: 'No access' };
    const associatedRoute = flattenedRoutes.find(r => r.name === route);
    if (!enactPageAccess || !associatedRoute) return noAccess;
    if (!associatedRoute.meta?.accessName) return { hasAccess: true, accessRequired: '' };

    const accessRequired = associatedRoute.meta?.accessName as keyof IEnactPagesAccess;
    const accessObject = enactPageAccess[accessRequired];
    const hasAccess = accessObject ? accessObject.hasAccess : false;
    return { hasAccess, accessRequired };
}
